import { useMemo } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'

import { ConfirmRevenueDialogContent } from './ConfirmRevenueDialogContent'

interface IProps {
  isShowDialog: boolean

  isRetailer: boolean

  onConfirm: () => void
  onClose: () => void
}

export const ConfirmRevenueDialog = ({ isShowDialog, isRetailer, onConfirm, onClose }: IProps) => {
  const contentProps = useMemo(() => {
    return { isRetailer, onConfirm, onClose }
  }, [isRetailer, onConfirm, onClose])

  return (
    <ModalDialog
      size={'xs'}
      show={isShowDialog}
      content={ConfirmRevenueDialogContent}
      contentProps={contentProps}
      onClose={onClose}
    />
  )
}
